const colors = require("tailwindcss/colors");

module.exports = {
  primary: "#24c347",
  secondaryYellow: "#ffcc00",
  tertiary: "#373737", //"#7d55c8",
  primarylight: "#e0f7ad",
  gray: colors.trueGray,
  c1: "#FF3C37",
  c2: "#FB7D7A",
  c3: "#FBAEAC",
  c4: "#6A97CE",
  c5: "#0A5FC8",
  "1light": "#ffeae9",
  nsnc: "#D9DAD9",
  lightgray: "#D9DAD9",
  darkgray: "#373737", //"#232323",
};
